export default "__VITE_ASSET__DZpBm2ds__"